import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import getApiClient from '../plugins/api'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard/Index')

const Login = () => import('@/views/pages/Login/Index')
const BoardingPass = () => import('@/views/pages/BoardingPass/Index')
const PasswordRecovery = () => import('@/views/pages/PasswordRecovery/Index')
const PasswordReset = () => import('@/views/pages/PasswordReset/Index')
const AgencyOrders = () => import('@/views/Agency/Orders/Index')
// const AgencyOrderDetails = () => import('@/views/Agency/Orders/components/OrderDetails/Index')
const OrderDetails = () => import('@/views/Orders/components/OrderDetails/Index')
const AgencyReservations = () => import('@/views/Agency/Reservations/Index')
const ReservationDetails = () => import('@/views/Agency/Reservations/components/ReservationDetails/Index')
const Trips = () => import('@/views/Trips/Index')
const TripList = () => import('@/views/Trips/components/TripList/Index')
const TripForm = () => import('@/views/Trips/components/TripForm/Index')
const CustomerForm = () => import('@/views/Customer/Form/Index')
const CustomerList = () => import('@/views/Customer/List/Index')
const CustomerRegister = () => import('@/views/pages/CustomerRegister/Index')
const Profile = () => import('@/views/Profile/Index')
const ChangePassword = () => import('@/views/Profile/components/ChangePassword/Index')
const SatisfactionSurvey = () => import('@/views/pages/SatisfactionSurvey/Index')
const ReplySatisfactionSurvey = () => import('@/views/pages/ReplySatisfactionSurvey/Index')
const OrderList = () => import('@/views/OrderList/Index')
const SellingProcess = () => import('@/views/SellingProcess/Index')
const Users = () => import('@/views/Users/Index')
const AgencyList = () => import('@/views/Agency/List/Index')
const AgencyForm = () => import('@/views/Agency/Form/Index')
const OrdersAll = () => import('@/views/Orders/Index')
const AbandonedCarts = () => import('@/views/AbandonedCarts/Index')

const SatisfactionSurveys = () => import('@/views/Surveys/List/Index')
const AgencySatisfactionSurveys = () => import('@/views/Surveys/AgencyList/Index')
const PendingSatisfactionSurveys = () => import('@/views/Surveys/PendingList/Index')

const Ads = () => import('@/views/Ads/Index')
const PostList = () => import('@/views/Posts/List/Index')
const PostForm = () => import('@/views/Posts/Form/Index')

const AgencyPayables = () => import('@/views/AgencyPayables/Index')
const PagarmePayables = () => import('@/views/PayableList/Index')
const AdminPayables = () => import('@/views/AdminPayables/Index')
const PixHistory = () => import('@/views/PixHistory/Index')
const TransferHistory = () => import('@/views/TransferHistory/Index')

const CompleteCart = () => import('@/views/pages/CompleteCart/Index')

const BoardingPlaces = () => import('@/views/BoardingPlaces/List/Index')
const BoardingPlaceForm = () => import('@/views/BoardingPlaces/Form/Index')

const HighlightReport = () => import('@/views/HighlightReport/Index')

const Purchase = () => import('@/views/Purchase/Index')
const Boosts = () => import('@/views/Boosts/List/Index')
const BoostsReport = () => import('@/views/Boosts/ReportList/Index')
const BoostDetails = () => import('@/views/Boosts/Details/Index')
const AdminBoostDetails = () => import('@/views/Boosts/AdminDetails/Index')
const HolidaysList = () => import('@/views/Holidays/List/Index')
const HolidaysForm = () => import('@/views/Holidays/Form/Index')
const CouponList = () => import('@/views/Coupons/List/Index')
const CouponForm = () => import('@/views/Coupons/Form/Index')

const SettingsList = () => import('@/views/Settings/List/Index')
const SettingsForm = () => import('@/views/Settings/Form/Index')

const CategoriesList = () => import('@/views/Categories/List/Index')
const CategoryForm = () => import('@/views/Categories/Form/Index')
const PlacesList = () => import('@/views/Places/List/Index')
const PlaceForm = () => import('@/views/Places/Form/Index')

const PagesList = () => import('@/views/Page/List/Index')
const PagesForm = () => import('@/views/Page/Form/Index')
const PagesView = () => import('@/views/Page/View/Index')

const PublicAgencyRegistration = () => import('@/views/Public/AgencyRegistration/Index')

const ModalsList = () => import('@/views/Modal/List/Index')
const ModalsForm = () => import('@/views/Modal/Form/Index')

const PagarmeChargebacksList = () => import('@/views/PagarmeChargebacks/List/Index')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

router.beforeEach((to, from, next) => {
  const api = getApiClient(store)
  if (to.meta.public) {
    return next()
  }

  if (store.state.modalLockdown && !to.path.startsWith('/profile')) {
    return next('/profile')
  }

  if (to.name !== 'Login' && ! store.state.jwtToken) {
    if (from.name !== 'Login') {
       return next({
         name: 'Login',
         params: {
           next: to.fullPath
         }
       })
    }
  }

  if (store.state.user.id) {
    api.get(`/user/${store.state.user.id}`)
        .then(user => {
          store.commit('setUser', user.data)
          router.routes = configRoutes()

          if (to.meta.allowedRoles) {
            let userRole = store.state.user.roles[0]

            if (! to.meta.allowedRoles.includes(userRole)) {
              next('/')
            }
          }
        })
        .catch(error => {

        })
  }
  next()
})

export default router

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'agency/orders',
          name: 'Pedidos',
          component: AgencyOrders,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'agency/orders/:id',
          name: 'Detalhes do pedido',
          component: OrderDetails,
          meta: {
            allowedRoles: ['ROLE_AGENCY', 'ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'agency/reservations',
          name: 'Reservas',
          component: AgencyReservations,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'agency/reservations/:id',
          name: 'Detalhes da reserva',
          component: ReservationDetails,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'users',
          name: 'Usuários',
          component: Users,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'agencies',
          name: 'Agências',
          component: AgencyList,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'agencies/:id/edit',
          name: 'Editar agência',
          component: AgencyForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'agencies/create',
          name: 'Criar agência',
          component: AgencyForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'posts/list',
          name: 'Recados para agências',
          component: PostList,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'posts/:id/edit',
          name: 'Editar recado',
          component: PostForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'posts/create',
          name: 'Publicar novo recado',
          component: PostForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'payables',
          name: 'Valores a repassar',
          component: AdminPayables,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'pix/:orderId?',
          name: 'Histórico de PIX',
          component: PixHistory,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'transfers/:orderId?',
          name: 'Histórico de Transferências',
          component: TransferHistory,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'highlight_report',
          name: 'Resumo',
          component: HighlightReport,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'orders/all',
          name: 'Pedidos',
          component: OrdersAll,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'abandoned_carts',
          name: 'Carrinhos abandonados',
          component: AbandonedCarts,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'orders/details/:id',
          name: 'Detalhes do pedido',
          component: OrderDetails,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'agency/payables',
          name: 'Recebíveis',
          component: AgencyPayables,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'agency/pagarme_payables',
          name: 'Recebíveis Pagar.me',
          component: PagarmePayables,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'orders/:id?',
          name: 'Meus Pedidos',
          component: OrderList,
          meta: {
            allowedRoles: ['ROLE_CUSTOMER']
          }
        },
        {
          path: 'surveys',
          name: 'Avaliações',
          component: SatisfactionSurveys,
          meta: {
            allowedRoles: ['ROLE_CUSTOMER']
          }
        },
        {
          path: 'received_surveys',
          name: 'Avaliações recebidas',
          component: AgencySatisfactionSurveys,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'pending_surveys',
          name: 'Avaliações pendentes',
          component: PendingSatisfactionSurveys,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE']
          }
        },
        {
          path: 'trips',
          name: 'Trips',
          component: Trips,
          children: [
            {
              path: 'list',
              name: 'Minhas Trips',
              component: TripList,
              meta: {
                allowedRoles: ['ROLE_AGENCY']
              }
            },
            {
              path: 'new',
              name: 'Criar Trip',
              component: TripForm,
              meta: {
                allowedRoles: ['ROLE_AGENCY']
              }
            },
            {
              path: ':id/edit',
              name: 'Editar Trip',
              component: TripForm,
              meta: {
                allowedRoles: ['ROLE_AGENCY']
              }
            },
            {
              path: 'new/:clone',
              name: 'Clonar Trip',
              component: TripForm,
              meta: {
                allowedRoles: ['ROLE_AGENCY']
              }
            }
          ]
        },
        {
          path: 'customers',
          name: 'Clientes',
          component: Trips,
          children: [
            {
              path: 'create',
              name: 'Cadastrar Cliente',
              component: CustomerForm,
              meta: {
                allowedRoles: ['ROLE_AGENCY']
              }
            },
            {
              path: 'list',
              name: 'Meus Clientes',
              component: CustomerList,
              meta: {
                allowedRoles: ['ROLE_AGENCY', 'ROLE_ADMIN', 'ROLE_SERVICE']
              },
              children: [
                {
                  path: 'trip/:idTrip',
                  name: 'Meus Clientes',
                  component: CustomerList,
                  meta: {
                    allowedRoles: ['ROLE_AGENCY']
                  }
                }
              ]
            },
          ]
        },
        {
          path: 'selling_process',
          name: 'Termos de aceite',
          component: SellingProcess,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'profile/:additionalInfo?',
          name: 'Minha conta',
          component: Profile
        },
        {
          path: 'change_password',
          name: 'Alterar senha',
          component: ChangePassword
        },
        {
          path: 'ads/:tripId?',
          name: 'Divulgação',
          component: Ads,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'purchase/:product/:tripId?',
          name: 'Impulsionar',
          component: Purchase,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'boosts',
          name: 'Minhas compras',
          component: Boosts,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'boosts/details/:id',
          name: 'Detalhes do impulsionamento',
          component: BoostDetails,
          meta: {
            allowedRoles: ['ROLE_AGENCY']
          }
        },
        {
          path: 'boarding_places',
          name: 'Locais de embarque',
          component: BoardingPlaces,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'boarding_places/edit/:id',
          name: 'Editar local de embarque',
          component: BoardingPlaceForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'boarding_places/new',
          name: 'Novo local de embarque',
          component: BoardingPlaceForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'boosts_report',
          name: 'Compras de impulsionamento',
          component: BoostsReport,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'boosts/admin/details/:id',
          name: 'Detalhes do impulsionamento',
          component: AdminBoostDetails,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'holidays',
          name: 'Feriados',
          component: HolidaysList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'holidays/new',
          name: 'Adicionar feriado',
          component: HolidaysForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'holidays/:id',
          name: 'Editar feriado',
          component: HolidaysForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'pages',
          name: 'Páginas',
          component: PagesList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'pages/new',
          name: 'Adicionar página',
          component: PagesForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'pages/:id',
          name: 'Editar página',
          component: PagesForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'page/:id',
          name: 'Página',
          component: PagesView,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_AGENCY']
          }
        },
        {
          path: 'modals',
          name: 'Modals',
          component: ModalsList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'modals/new',
          name: 'Adicionar modal',
          component: ModalsForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'modals/:id',
          name: 'Editar modal',
          component: ModalsForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'chargebacks',
          name: 'Chargebacks',
          component: PagarmeChargebacksList,
          meta: {
            allowedRoles: ['ROLE_ADMIN', 'ROLE_AGENCY']
          }
        },
        {
          path: 'categories',
          name: 'Categorias de destinos',
          component: CategoriesList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'categories/new',
          name: 'Adicionar cateoria',
          component: CategoryForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'categories/:id',
          name: 'Editar categoria',
          component: CategoryForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'places',
          name: 'Destinos',
          component: PlacesList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'places/new',
          name: 'Adicionar destino',
          component: PlaceForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'places/:id',
          name: 'Editar destino',
          component: PlaceForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'terms',
          name: 'Termos de aceite',
          component: SellingProcess,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'coupons',
          name: 'Cupons',
          component: CouponList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'coupons/new',
          name: 'Adicionar cupom',
          component: CouponForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'coupons/:id',
          name: 'Editar cupom',
          component: CouponForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'settings',
          name: 'Configurações',
          component: SettingsList,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
        {
          path: 'settings/:id',
          name: 'Editar configuração',
          component: SettingsForm,
          meta: {
            allowedRoles: ['ROLE_ADMIN']
          }
        },
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/:next?',
          name: 'Login',
          component: Login,
          meta: {
            public: true
          }
        },
        {
          path: 'customer/register/:token/:cartToken',
          name: 'Customer register',
          component: CustomerRegister,
          meta: {
            public: true
          }
        },
        {
          path: 'agency/register',
          name: 'Agency registration',
          component: PublicAgencyRegistration,
          meta: {
            public: true
          }
        },
        {
          path: 'customer/complete_cart/:id',
          name: 'Complete cart',
          component: CompleteCart,
          meta: {
            public: true
          }
        },
        {
          path: 'boarding-pass/:hash',
          name: 'Boarding pass',
          component: BoardingPass,
          meta: {
            public: true
          }
        },
        {
          path: 'boarding-pass/validator/:hash',
          name: 'Boarding pass',
          component: BoardingPass,
          meta: {
            public: true
          }
        },
        {
          path: 'password_recovery',
          name: 'PasswordRecovery',
          component: PasswordRecovery,
          meta: {
            public: true
          }
        },
        {
          path: 'first_access',
          name: 'FirstAccess',
          component: PasswordRecovery,
          meta: {
            public: true
          }
        },
        {
          path: 'password_reset/:token/:firstAccess?',
          name: 'PasswordReset',
          component: PasswordReset,
          meta: {
            public: true
          }
        },
        {
          path: 'survey/:id/reply',
          name: 'Responder Pesquisa de Satisfação',
          component: ReplySatisfactionSurvey,
          meta: {
            public: true
          }
        },
        {
          path: 'survey/:id/:edit?',
          name: 'Pesquisa de Satisfação',
          component: SatisfactionSurvey,
          meta: {
            public: true
          }
        },
      ]
    }
  ]
}

